import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CompilationModel, PackingConditions, PalletLabelConfig } from '../../../../../@models/erp/compilation';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../../../../@core/service/api.service';
import { IDropdownOptions, SharedDataService } from '../../../../../@core/service/shared-data.service';
import { TreeService } from '../../../../../@core/service/tree.service';
import { DownloadConfig } from '../document-printer.component';
import { getDocumentNumber, mongoId } from '../../../../../@core/common/global';
import * as saveAs from 'file-saver';
import { DocConfig, UnitData } from '../../../../../@models/erp/compilationData';
import { PackingConditionsComponent } from '../../packing-conditions/packing-conditions.component';
import { WarehousingComponent } from '../../../../warehousing/warehousing.component';
import { AuthGuardService } from '../../../../../@core/service/auth-guard.service';
import { PopupDocumentComponent } from '../popup-document/popup-document.component';
import { NrkWindowComponent } from '../../../shared/nrk-window/nrk-window.component';
import { RoundPipe } from '../../../../../@theme/pipes';
import { DocMetrics } from '../../line-item-container/line-item-metrics/line-item-metrics.component';
import { BusinessModel, EContactType } from '../../../../../@models';
import { ContactUtil } from '../../../shared/doc-form-address-selector/doc-form-address-selector.component';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ngx-pallet-label',
  templateUrl: './pallet-label.component.html',
  styleUrls: ['./pallet-label.component.css', '../document-printer.component.css']
})
export class PalletLabelComponent implements AfterViewInit, OnChanges {

  @Input() compilation: CompilationModel;
  @Input() grossWeight: number;
  @Input() warehousingPopup = false;

  @ViewChild('coverSheet') coverSheet: ElementRef;
  @ViewChild('palletLabelLegacy') palletLabelLegacy: ElementRef;
  // @ViewChild('packingConditions') packingConditions: PackingConditionsComponent;

  @ViewChild('palletLabel') palletLabel: ElementRef;
  @ViewChild('palletLabelWindow') palletLabelWindow: NrkWindowComponent;


  unitData = UnitData;
  display = 'none';
  print = false;
  insidePalletLabel = false;

  packingTypeOptions: IDropdownOptions[][] = [];
  packingForIdx: { [idx: number]: { [pidx: number]: any } } = []; 
  palletInfo: { [palletId: string]: any };
  currentDm = [];

  public multiPalletColors = [ 'cornflowerblue', 'mediumseagreen', 'orange' ];

  constructor(
    private api: ApiService,
    public data: SharedDataService,
    private datePipe: DatePipe,
    public tree: TreeService,
    private cdRef: ChangeDetectorRef,
    private auth: AuthGuardService,
    private toast: NbToastrService,
  ) { }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.compilation && !this.compilation.palletLabelConfig) {
      this.compilation.palletLabelConfig = new PalletLabelConfig();
    }
    this.reloadData();
  }

  ngAfterViewInit(): void {
    // this.resizeToMatchHeight(450);
    // console.log('pallet label component after view init')
    // this.palletLabelWindow.show();
  }

  reloadData() {
    this.compilation.lineItems.forEach((li, idx) => {
      this.currentDm[idx] = new DocMetrics(this.api, this.compilation, li, new RoundPipe(), this.data, true);
      this.packingForIdx[idx] = [];
      this.getPackingFor(idx)?.forEach((pal, pidx) => {
        this.packingForIdx[idx][pidx] = pal?.items[0]?.typeOfBox;
      })

    })
    this.palletInfo = this.getPalletInfo();
  }

  // resizeToMatchHeight(height: number) {
  //   this.compilation.lineItems.forEach((li, idx) => {
  //     this.getPackingFor(idx).forEach((pallet, pidx) => {

  //       const id = 'innerDiv-' + this.compilation.lineItems.length * idx + pidx;
  //       const el = document.getElementById(id)

  //       const outerDivHeight = height;
  //       const innerDivHeight = el.clientHeight;
        
  //       if (innerDivHeight > outerDivHeight && outerDivHeight > 0 && innerDivHeight > 0) {
  //         const scaleFactor = outerDivHeight / innerDivHeight;
  //         // console.log('scale factor', id, el.clientHeight, scaleFactor);
  //         // el.style.transform = `scaleY(${scaleFactor})`;
  //         el.setAttribute('style', `-webkit-transform-origin:top;-webkit-transform:scaleY(${scaleFactor});height:${innerDivHeight*scaleFactor}px`);
  //       }    
  //     })
  //   })
  // }

  printPackingInforamtion() {
    this.downloadPdf('cover');
    this.insidePalletLabel = true;
    this.downloadPdf('window');
    this.insidePalletLabel = false;
  }

  downloadPdf(type: string) {

    this.display = 'block';
    this.print = true;
    this.cdRef.detectChanges();

    const config = new DownloadConfig();
    config.css = 'document-printer.css';
    config.footer = ''

    if (type === 'legacy') {
      config.html = this.palletLabelLegacy.nativeElement.innerHTML;
      config.orientation = 'landscape';

      this.api.getDocumentFile('/api/v1/compilation/pdf', config).subscribe(async res => {
        
        // this.display = 'none';
        // this.cdRef.detectChanges();
        const date = this.datePipe.transform(this.compilation.issueDate ? this.compilation.issueDate : new Date(), 'yyMMdd');
        const docnum = getDocumentNumber(this.compilation);
        const company = this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient))?.name
        await this.data.loadBusinesses();
        if (res.size) saveAs(res, `${date}_${company}_${docnum}_Palletlabel.pdf`);
        PopupDocumentComponent.addWarehousingLog(this.compilation, this.data, this.api, this.auth, 'Print Pallet Labeling');
        
      });
    } else if (type === 'cover') {
      config.html = this.coverSheet.nativeElement.innerHTML;
      config.orientation = 'portrait';
  
      this.api.getDocumentFile('/api/v1/compilation/pdf', config).subscribe(async res => {
  
        const date = this.datePipe.transform(this.compilation.issueDate ? this.compilation.issueDate : new Date(), 'yyMMdd');
        const docnum = getDocumentNumber(this.compilation);
        const company = this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient))?.name
        if (res.size) saveAs(res, `${date}_${company}_${docnum}_Packing_information.pdf`);
        PopupDocumentComponent.addWarehousingLog(this.compilation, this.data, this.api, this.auth, 'Print Packing Information');
  
      });

      // this.coverSheet.nativeElement.getElementById('cover-sheet-gross-weight').display = 'none';
      // config.html = this.coverSheet.nativeElement.innerHTML;

      // this.api.getDocumentFile('/api/v1/compilation/pdf', config).subscribe(async res => {
  
      //   const date = this.datePipe.transform(this.compilation.issueDate ? this.compilation.issueDate : new Date(), 'yyMMdd');
      //   const docnum = getDocumentNumber(this.compilation);
      //   const company = this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient))?.name
      //   if (res.size) saveAs(res, `${date}_${company}_${docnum}_Inside_Pallet_Label.pdf`);
      //   // PopupDocumentComponent.addWarehousingLog(this.compilation, this.data, this.api, this.auth, 'Print Packing Information');
  
      // });

 
    } else {
      config.html = this.palletLabel.nativeElement.innerHTML;
      config.css = null;
      config.cssFiles = ['pallet-label.component.css'];
      config.orientation = 'portrait';
      config.noheader = true;
      config.nofooter = true;
      config.nomargin = true;

      const insidePalletLabel = this.insidePalletLabel;

      this.api.getDocumentFile('/api/v1/compilation/pdf', config).subscribe(async res => {
        
        // this.display = 'none';
        // this.cdRef.detectChanges();
        const date = this.datePipe.transform(this.compilation.issueDate ? this.compilation.issueDate : new Date(), 'yyMMdd');
        const docnum = getDocumentNumber(this.compilation);
        const company = this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient))?.name
        await this.data.loadBusinesses();
        if (res.size) saveAs(res, `${date}_${company}_${docnum}_${insidePalletLabel ? 'Inside_' : ''}Palletlabel.pdf`);
        if (!insidePalletLabel) PopupDocumentComponent.addWarehousingLog(this.compilation, this.data, this.api, this.auth, 'Print Pallet Labeling');
        
      });

    }

    this.display = 'none'
    this.print = false;
    this.cdRef.detectChanges();

  }

  isMixedPallet() {
    return this.compilation.packingConditions.find(f => f.palletType === 'P9');
  }

  getPackingFor(idx: number) {
    // console.log('====>getPackingFor', idx, this.compilation.packingConditions.filter(f => f.lineItemIdx === idx));
    return this.compilation.packingConditions.filter(f => f.lineItemIdx === idx);
  }


  getSumBoxes(pallet: PackingConditions) {
    return pallet.items?.reduce((a, c) => a + (+c.numberOfBoxes), 0)
  }

  getPos(pallet: PackingConditions) {
    return this.compilation.packingConditions.findIndex(f => f === pallet) + 1;
  }

  getUnitQuantity(lidx: number, row: any) {
    const pieces = row.quantity;
    const lineItem = this.compilation.lineItems[lidx];
    const unit = lineItem?.displayUnit;
    const quantity = this.currentDm[lidx]?.metrics?.convert(+pieces, 1, unit);
    // row['unitQuantity'] = quantity;
    // console.log('getUnitQuantity', lidx, row, pieces, lineItem, unit, quantity);
    return `${quantity} ${UnitData.get(unit)?.short}`;
  }

  private getPalletInfo(): { [palletId: string]: any }  {

    // if (this.compilation.useOldPackingConditions) return;
    console.time('get pallet info')

    const info = {} as any;

    this.compilation.packingConditions.forEach(pal => {

      // console.log('pallet--:', pal.palId, pal);
      if (!info[pal.palId]) info[pal.palId] = {};

      info[pal.palId].pal = pal;
      info[pal.palId].palPos = `Pal ${this.getPos(pal)}/${this.compilation.packingConditions.length}`;
      info[pal.palId].id = pal.palId;
      info[pal.palId].palletType = pal.palletType === 'P0' ? 'no pallet' : this.data.getOptionName(this.data.palletTypeOptions, pal.palletType);
      info[pal.palId].dimensions = pal.dimensions;
      info[pal.palId].dn = `${this.tree?.linkedDN?.code|| this.compilation.code} Pos ${pal.lineItemIdx+1}`;
      info[pal.palId].boxes = this.getSumBoxes(pal);
      info[pal.palId].netWeight = Math.round(pal.items?.reduce((a, c) => a + (+c.netWeight || 0), 0));
      info[pal.palId].grossWeight = Math.round(pal.weightOverride || pal.weight || 0);
      info[pal.palId].items = [];

      pal.items?.forEach(row => {

        info[pal.palId].items.push({
          row: row,
          cs: row.csNr,
          tc: row.tcNr,
          boxes: row.numberOfBoxes,
          quantity: row.quantity,
          unitQuantity: this.getUnitQuantity(pal.lineItemIdx, row),
          typeOfBox: this.data.getOptionName(this.data.cartonBoxOptions, row.typeOfBox),
          netWeight: row.netWeight.toFixed(1),
        })

      })

      // console.log('current pallet info', info, pal);

    })

    // this.totalNetWeight = Object.values(info).reduce((a: number, c: any) => a + (+c?.netWeight || 0), 0) as number;
    // this.totalGrossWeight = Object.values(info).reduce((a: number, c: any) => a + (+c?.grossWeight || 0), 0) as number;

    // console.timeEnd('get pallet info')

    // console.log('getPalletInfo', info);

    return info;
  }

  getMultiPalletColor(pallet: PackingConditions) {
    // const idx = this.compilation.packingConditions?.filter(f => f.palletType === 'P9')?.findIndex(p => p === pallet);
    // if (idx >= 0 && idx < 3) return this.multiPalletColors[idx];
    const idx = this.compilation.packingConditions?.filter(f => f.palRef)?.findIndex(p => p === pallet);
    if (idx >= 0 && idx < 3) return this.multiPalletColors[idx];
  }

  getDeliveryAddress() {
    // return (new ContactUtil(this.data)).getAddressFromBusiness(
    //   mongoId(this.compilation.deliveryRecipient), 
    //   DocConfig.get('palletLabelAddress').fields, 
    //   EContactType.General,
    //   false
    // )
    const lines = this.compilation?.deliveryAddress?.split(/\n/);
    if (!lines?.length) return '';
    const lastLine = lines.splice(lines.length-1,1);
    lines[lines.length-1] += ', ' + lastLine;
    return lines.join('\n');
  }

  async saveData() {
    const doc = await this.api.loadCompilation(mongoId(this.compilation));
    doc.palletLabelConfig = this.compilation.palletLabelConfig;
    console.log('modified doc svd', doc.palletLabelConfig, doc)
    this.api.saveCompilation(doc).then((dox) => {
        this.toast.success('Data successfully saved', 'Pallet');
        console.log('svd', dox)
      }
    );
  }



}
